"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = typography;

var _utils = require("@tablekit/utils");

var _fontSettings = require("./fontSettings");

function typography(level) {
  var defaultLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L3';
  return function (props) {
    var types = (0, _utils.getThemeValue)('typography', _fontSettings.DEFAULT_TYPOGRAPHY)(props);
    return types[level] || types[defaultLevel];
  };
}